import React from "react"
import { useStaticQuery, graphql, Link } from "gatsby"
import Layout from "../components/layout"
import SEO from "../components/seo"
import { Card, Container } from 'semantic-ui-react'

import styles from '../styles/pages/blog.module.scss'


const IndexPage = () => {
  const data = useStaticQuery(graphql`
    query {
      blogPost: allMarkdownRemark(limit: 10) {
        nodes {
          frontmatter {
            date(formatString: "MMMM DD, YYYY")
            path
            title
            time
          }
        }
      },
    }
  `)

  return (
    <Layout>
      <SEO title="Blog" />
      <Container>
        <Card.Group className={styles.wrapper}>
          {data.blogPost.nodes.map((b, k) => (
            <Card fluid key={k}>
              <Card.Content>
                <Card.Header><Link to={b.frontmatter.path}>{b.frontmatter.title}</Link></Card.Header>
                <Card.Meta>{`Lectura: ${b.frontmatter.time}`}</Card.Meta>
              </Card.Content>
            </Card>
          ))}
        </Card.Group>
      </Container>
    </Layout>
  )
}

export default IndexPage
